import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

export const BUSINESS_DOCUMENTS_TAGS = Object.freeze({
  INDEX: 'business_documents_index',
});

export const businessDocumentsApiSlice = createApi({
  tagTypes: Object.values(BUSINESS_DOCUMENTS_TAGS),
  reducerPath: 'businessDocumentsApiSlice',
  baseQuery,
  endpoints: (builder) => ({
    getBusinessDocuments: builder.query({
      query: ({ apiManager, params }) => apiManager.getDocuments(params),
      providesTags: [BUSINESS_DOCUMENTS_TAGS.INDEX],
    }),
    submitBusinessDocument: builder.mutation({
      query: ({ apiManager, data }) => apiManager.submit(data),
      invalidatesTags: (_, error) => (error ? [] : [BUSINESS_DOCUMENTS_TAGS.INDEX]),
    }),
    uploadBusinessDocument: builder.mutation({
      query: ({ apiManager, data }) => apiManager.uploadDocument(data),
      invalidatesTags: (_, error) => (error ? [] : [BUSINESS_DOCUMENTS_TAGS.INDEX]),
    }),
    deleteBusinessDocument: builder.mutation({
      query: ({ apiManager, ids, isHardDelete }) => apiManager.deleteDocuments({ ids, isHardDelete }),
      invalidatesTags: (_, error) => (error ? [] : [BUSINESS_DOCUMENTS_TAGS.INDEX]),
    }),
  }),
  serializeQueryArgs,
});

export const {
  useGetBusinessDocumentsQuery,
  useSubmitBusinessDocumentMutation,
  useUploadBusinessDocumentMutation,
  useDeleteBusinessDocumentMutation,
} = businessDocumentsApiSlice;
